import React, { Component } from "react";

import { Link } from "react-router-dom";

import VeranstaltungServiceInstance from "../services/VeranstaltungService"

export default class Veranstaltung extends Component {
    constructor(props) {
        super(props);
        this.state = { event: {}, id: Number(props.match.params.id) };
    }

    componentDidMount() {
        VeranstaltungServiceInstance.getById(this.state.id).then(event => {
            this.setState({ event: event });
        }).catch(err => console.log("fehler", err));
    }

    render() {
        const eventId = this.state.id;
        // const eventDescription = event.beschreibung.split("\n").map((par,k) => <p key={k}>{par}</p>);
        const beschreibung = this.state.event.beschreibung ? this.state.event.beschreibung : "";
        const eventDescription = beschreibung.split("\n").map((par, k) => <p key={k}>{par}</p>);

        const isAnmeldungNochMoeglich = this.state.event.anmeldeschluss ? new Date(this.state.event.anmeldeschluss).getTime() > new Date().getTime() : false;
        const anmeldeinformationen = isAnmeldungNochMoeglich ? (<div style={{marginTop: 50}}>
            <h3>Anmeldung</h3>
            <p>Wenn Sie selbst an der Veranstaltung teilnehmen möchten, können Sie sich als Einzelsportler anmelden. Falls Sie z.B. als Trainer gleich mehrere Sportler melden möchten, ist dies ebenfalls möglich.</p>

            <div className="row" >
                <div className="col-lg-4 col-md-6 col-sm-12"><Link className="btn btn-primary btn-block jh-space-top-tiny jh-btn" to={"/anmeldung/" + eventId + "/sportler"}>Einzelnen Sportler anmelden</Link></div>
                <div className="col-lg-4 col-md-6 col-sm-12"><Link className="btn btn-primary btn-block jh-space-top-tiny jh-btn" to={"/anmeldung/" + eventId + "/trainer"}>Mehrere Sportler anmelden</Link></div>
            </div>

            <p>
                 
            </p>
        </div>) : (<div style={{marginTop: 30}}><p>Die Anmeldung ist mittlerweile leider geschlossen - Anmeldungen sind nur noch vor Ort möglich.</p></div>);

        return (
            <div className="jh-content">
                <div className="row" >
                    <div className="col-md-12">
                        <h1>{this.state.event.name}</h1>
                        <h5 className="jh-subheader">Veranstalter: {this.state.event.veranstalter} - Datum: {this.state.event.datum}</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {eventDescription}

                        {anmeldeinformationen}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Veranstaltung.js